module.exports = __webpack_public_path__ + "media/student_contributors/04NicoleManges-11fb6232.png";